import {Component, OnInit, ViewChild} from '@angular/core';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {DynamicBlacklistApiService} from '../../services/api/dynamic-blacklist/dynamic-blacklist-api.service';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {ArmTableComponent} from '../../components/arm-table/arm-table.component';
import {ConfirmationDialogComponent} from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {DateTimeSecPipe} from '../../pipes/date-time/date-time-sec.pipe';
import {Router} from '@angular/router';
import _ from 'lodash';

@Component({
  selector: 'dynamic-blacklist',
  templateUrl: './dynamic-blacklist.component.html',
  styleUrls: ['./dynamic-blacklist.component.scss']
})
export class DynamicBlacklistComponent implements OnInit {

  @ViewChild(ArmTableComponent) armTable;

  isUnauthorized: boolean;
  items: any;

  displayedColumns: Array<DisplayedColumnInf> = [
    {name: 'number', display: 'Blocked number', selected: true, width: 100},
    {name: 'policyStudioName', display: 'Policy name', selected: true, width: 200},
    {name: 'hits', display: 'Number of blocked calls', selected: true, width: 100},
    {name: 'startBT', display: 'Start blocking time', selected: true, width: 100, transformer: DateTimeSecPipe},
    {name: 'endBT', display: 'End blocking time', selected: true, width: 100, transformer: DateTimeSecPipe},
    {name: 'direction', display: 'Direction', selected: true, width: 100}];

  filter: any;
  selection: any[];
  emptyCalls: boolean;
  emptySelection: boolean;

  constructor(private router: Router,
              private userPrivilege: UserPrivilegeService,
              public dialog: MatDialog,
              private dynamicBlacklistService: DynamicBlacklistApiService) { }

  ngOnInit(): void {
    this.emptyCalls = true;
    this.emptySelection = true;
    this.isUnauthorized = !this.userPrivilege.isAuthorized();
    this.refresh();
  }

  removeItem(allOrSelected: any): void  {

    const confirmationMessage = `Are you sure you want to delete ${allOrSelected === 'all' ? 'all' : this.selection.length === 1 ? 'this' : 'these' } blocked number${(allOrSelected === 'selected' && this.selection.length === 1) ? '' : 's'}  ?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      if (allOrSelected === 'selected') {
        this.dynamicBlacklistService.unblockNumber(this.selection).then(() => {
          dialogRef.close();
          this.refresh();
        }).catch((error) => {
          console.log(`Exception was thrown in remove  ${this.selection}, reason: ${error}`);
        });
      } else {
        this.dynamicBlacklistService.unblockAllNumbers().then(() => {
          dialogRef.close();
          this.refresh();
        }).catch((error) => {
          console.log(`Exception was thrown in remove the numbers, reason: ${error}`);
        });
      }
    });
  }

  refresh(): void  {
    this.emptyCalls = true;
    this.emptySelection = true;
    this.dynamicBlacklistService.getBlacklistForTable().subscribe(res => {
      this.items = res;
      this.emptyCalls = _.isEmpty(this.items);
    });
  }

  moveToCalls(): void {
    this.router.navigate(['/calls/callsList', {
      policyStudioId: this.selection[0].policyId,
      source: this.selection[0].direction === 'SOURCE' ? this.selection[0].number : '',
      destination: this.selection[0].direction === 'DESTINATION' ?  this.selection[0].number : '',
      startDate: this.selection[0].startBT,
      endDate:  this.selection[0].endBT
    }]);
  }

  select(selected: any[]): void  {
    this.selection = selected;
    if (this.selection.length > 0){
      this.emptySelection = false;
    }
  }

  onFilter(filter: string): void  {
    this.armTable.firstPage();
    this.filter = filter;
  }
}
